'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckboxTheme = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Checkbox = require('./Checkbox.scss');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckboxTheme = exports.CheckboxTheme = {
  APP_COLOR: 'appColor',
  DARK: 'dark',
  LIGHT: 'light'
};

var Checkbox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Checkbox, _Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      _this.props.onCheckboxChange(event.target.checked);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checkboxId = _props.checkboxId,
          isChecked = _props.isChecked,
          theme = _props.theme;

      return _react2.default.createElement(
        'div',
        { className: _Checkbox2.default.checkboxComponent + ' ' + theme },
        _react2.default.createElement(
          'div',
          { className: _Checkbox2.default.checkboxContent },
          _react2.default.createElement('input', { type: 'checkbox', id: checkboxId, className: _Checkbox2.default.checkbox, checked: isChecked, onChange: this.handleChange }),
          _react2.default.createElement('label', { htmlFor: checkboxId, className: _Checkbox2.default.checkboxStyle })
        )
      );
    }
  }]);
  return Checkbox;
}(_react.Component), _class.defaultProps = {
  className: '',
  isChecked: false,
  theme: CheckboxTheme.LIGHT
}, _class.propTypes = {
  checkboxId: _react.PropTypes.string,
  onCheckboxChange: _react.PropTypes.func.isRequired,
  isChecked: _react.PropTypes.bool,
  theme: _react.PropTypes.string
}, _temp2);
exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox/Checkbox.js
// module id = 166
// module chunks = 0